export const StatusColorMap = {
    highlighted: '#f8c623',
    busy: '#008ac4',
    old: '#ff7800',
    inactive: '#9b9b9b',
    closed: '#d0021b',
    finished: '#00b900',
    future: '#000000',
};
export const StatusSelectColorMap = {
    highlighted: 'rgba(248, 198, 35, 0.2)',
    busy: 'rgba(0, 138, 196, 0.2)',
    old: 'rgba(255, 120, 0, 0.2)',
    inactive: 'rgba(128, 128, 128, 0.2)',
    closed: 'rgba(208, 2, 27, 0.2)',
    finished: 'rgba(0, 185, 0, 0.2)',
    future: 'rgb(0, 0, 0)',
};
